'use client';

import { CircleNotch } from '@phosphor-icons/react';
import { FC, ReactNode } from 'react';

type LoadingBtnContentProps = {
  loadingChildren: ReactNode;
  children: ReactNode;
};

export const LoadingBtnContent: FC<LoadingBtnContentProps> = ({
  children,
  loadingChildren,
}) => {
  return (
    <div className="flex items-center justify-center text-center">
      <CircleNotch size={15} className="mr-2 animate-spin" />
      {loadingChildren ? loadingChildren : children}
    </div>
  );
};
